module.exports = __webpack_public_path__ + "static/media/IMG_7287_DxO.21e4574d.jpg";